import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import HistoryIcon from '@material-ui/icons/History';
import BuildIcon from '@material-ui/icons/Build';
import SearchIcon from '@material-ui/icons/Search';

export const VUES_COCKPIT = [
  {
    cle: 'terrain',
    chemin: '/cockpit',
    titre: 'Temps reel terrain',
    question: 'Dois-je intervenir maintenant ?',
    intention: 'Supervision active, mobile, pression match.',
    Icone: PhoneAndroidIcon,
  },
  {
    cle: 'sante',
    chemin: '/cockpit/sante-recente',
    titre: 'Sante recente',
    question: "Comment le systeme s'est-il comporte recemment ?",
    intention: 'Recul quotidien, confiance, stabilite.',
    Icone: HistoryIcon,
  },
  {
    cle: 'amelioration',
    chemin: '/cockpit/amelioration',
    titre: 'Amelioration systeme',
    question: 'Quelles fragilites devrait-on corriger ensuite ?',
    intention: 'Patterns, dette runtime, priorites produit.',
    Icone: BuildIcon,
  },
  {
    cle: 'investigation',
    chemin: '/cockpit/investigation',
    titre: 'Investigation',
    question: "Que s'est-il passe exactement ?",
    intention: 'Preuves, timelines, logs, detail technique.',
    Icone: SearchIcon,
  },
];

const useStyles = makeStyles((theme) => ({
  enveloppe: {
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    border: '1px solid #e5e7eb',
    boxShadow: 'none',
  },
  entete: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1),
  },
  question: {
    color: '#374151',
    fontWeight: 600,
  },
  intention: {
    color: '#6b7280',
    fontSize: 12,
  },
  nav: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
    gap: theme.spacing(1),
  },
  bouton: {
    justifyContent: 'flex-start',
    textAlign: 'left',
    minHeight: 46,
    textTransform: 'none',
  },
  boutonActif: {
    justifyContent: 'flex-start',
    textAlign: 'left',
    minHeight: 46,
    textTransform: 'none',
    borderColor: '#111827',
    backgroundColor: '#f9fafb',
  },
}));

const CockpitNavigation = ({ vueActive }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const vue = VUES_COCKPIT.find((item) => item.cle === vueActive)
    || VUES_COCKPIT.find((item) => item.chemin === location.pathname)
    || VUES_COCKPIT[0];

  return (
    <Paper className={classes.enveloppe}>
      <div className={classes.entete}>
        <div>
          <Typography variant="overline">Cockpit SyncCam</Typography>
          <Typography variant="body1" className={classes.question}>{vue.question}</Typography>
          <Typography variant="body2" className={classes.intention}>{vue.intention}</Typography>
        </div>
      </div>
      <div className={classes.nav}>
        {VUES_COCKPIT.map((item) => {
          const Icone = item.Icone;
          const actif = item.cle === vue.cle;
          return (
            <Button
              key={item.cle}
              variant="outlined"
              size="small"
              startIcon={<Icone />}
              className={actif ? classes.boutonActif : classes.bouton}
              onClick={() => history.push(item.chemin)}
            >
              {item.titre}
            </Button>
          );
        })}
      </div>
    </Paper>
  );
};

export default CockpitNavigation;



// WEBPACK FOOTER //
// src/components/cockpit/CockpitNavigation.js